import { useDebugValue } from 'react';
import { useSelector } from 'react-redux';
import { AsyncEntity } from '../../global';
import { RootState } from '../../store';
import { devicesSelectors } from './devicesTypes.state';
import { DeviceType } from './devicesTypes.types';

export const useDevicesState = (): RootState['devicesTypes'] => {
  const devices = useSelector<RootState, RootState['devicesTypes']>(state => state.devicesTypes);

  useDebugValue(devices);

  return devices;
};

export const useDevicesTypes = (): DeviceType[] => {
  const devices = useSelector<RootState, RootState['devicesTypes']>(state => state.devicesTypes);

  const result = devicesSelectors.selectAll(devices);

  useDebugValue(result);

  return result;
};

export const useDeviceByName = (name: string): AsyncEntity<DeviceType> | null => {
  const devices = useSelector<RootState, RootState['devicesTypes']>(state => state.devicesTypes);

  const result = devicesSelectors.selectById(devices, name) || null;

  useDebugValue(result);

  return result;
};
